import { Component, OnInit } from '@angular/core';
import { ApirequestService } from '../../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../../services/api-urls/apiurls.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInDown } from 'ng-animate';
import { trigger, transition, useAnimation } from '@angular/animations';
import { MatDialog } from '@angular/material';
import { EditUserInfoComponent } from '../../edit/edit-user-info.component';

@Component({
  selector: 'hybse-admin-investor-edit-user',
  templateUrl: './investor-edit-user.component.html',
  styleUrls: ['./investor-edit-user.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class InvestorEditUserComponent implements OnInit {

  public idUser: string;
  public userDetails: any = [];
  public wallectDetails: any[];
  public demoWallets: any[];
  public demoBuyOrder: any[];
  public demoSellOrder: any[];
  public buyOrder: any[];
  public sellOrder: any[];
  public iboBuyOrder: any[];
  public iboSellOrder: any[];
  public type: string;
  public userType: string;
  public errorMessage: string;
  public noRecord: string;
  public sellStatus: string;
  public buyStatus: string;
  public buyType: string;
  public sellType: string;
  public tabIndex: number;

  constructor(private _req: ApirequestService,
    private _url: ApiurlsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog) {
    this.activatedRoute.data.subscribe(
      (data: any) => {
        this.type = data.type;
      });
  }

  ngOnInit() {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.idUser = params['idUser'];
        this.userType = params['userType']
      });
    this.getUserDetails();
    localStorage.setItem('idUser', this.idUser);
  }

  private getUserDetails(): void {
    let data = {
      data: { idUser: this.idUser }
    };
    if (this.userType === 'Issuer') {
      this._req.fetchApiData(this._url.detailedUserInfo, data).subscribe(
        (data: any) => {
          this.userDetails = data.data;
        },
        err => { },
        () => { });
      this.getUserWallets(data);
      this.getBuyorderList(data);
      this.getSellorderList(data);
      this.getIboSellOrderList(data);


      // this.getTradingHestory();
    } else {
      this._req.fetchApiData(this._url.detailedUserInfo, data).subscribe(
        (data: any) => {
          this.userDetails = data.data;
        },
        err => { },
        () => { });
      this.getUserWallets(data);
      this.getBuyorderList(data);
      this.getSellorderList(data);
      this.getIboBuyOrderList(data);

      // this.getTradingHestory();
    }
  }

  private getUserWallets(data): void {
    this._req.fetchApiData(this._url.viewWalletUrl, data).subscribe(
      (data) => {
        this.wallectDetails = data['data'];
      }, (error) => {
      });
  }

  private getBuyorderList(data): void {
    this._req.fetchApiData(this._url.userBuyorderList, data).subscribe(
      (data) => {
        if (data) {
          let success = data['data'];
          let error = data['error'];
          if (success !== "") {
            this.buyOrder = success;
            this.buyOrder.forEach((item) => {
              if (item.isDeleted) {
                this.buyType = 'cancel';
              } else if (!item.isDeleted && !item.isMatched) {
                this.buyType = 'open order'
              } else {
                this.buyType = 'Matched'
              }
            });

          } else {
            this.errorMessage = error['Error Description']
          }
        }
      }, (error) => {
      });
  }

  private getSellorderList(data): void {
    this._req.fetchApiData(this._url.userSellorderList, data).subscribe(
      (data) => {
        if (data) {
          let success = data['data'];
          let error = data['error'];
          if (success !== "") {
            this.sellOrder = success;
            this.sellOrder.forEach((item) => {
              if (item.isDeleted) {
                this.sellType = 'cancel';
              } else if (!item.isDeleted && !item.isMatched) {
                this.sellType = 'open order'
              } else {
                this.sellType = 'close'
              }
            });
          } else {
            this.errorMessage = error['Error Description']
          }
        }
      }, (error) => {
      });
  }

  public onEdit() {
    this.dialog.open(EditUserInfoComponent, {
      width: "700px",
      height: "800px",
      data: { data: this.userDetails }
    }).afterClosed().subscribe((obj) => {
      if (obj) {
        if (obj.status == 'submit') {
          this.updateDetailedUserInfo(obj.data)
        }
      }
    });
  }

  private updateDetailedUserInfo(data): void {
    data['data'] = { idUser: this.idUser }
    this._req.fetchApiData(this._url.updateUserInfoByAdmin, data, 'post').subscribe(
      (data) => {
        console.log(data);

      }, (error) => {
      });
  }

  private getIboBuyOrderList(data): void {
    data['data'] = { idUser: this.idUser }
    this._req.fetchApiData(this._url.iboBuyListUrl, data).subscribe(
      (data) => {
        let resSucc = data['data'];
        if (resSucc !== '') {
          this.iboBuyOrder = data['data'];
        } else {
          this.noRecord = data['error']['errorDescription'];
        }
      }, (error) => {
      });
  }

  public tabChanged(event): void {
    this.tabIndex = event.index;



  }
  private getIboSellOrderList(data): void {
    data['data'] = { idUser: this.idUser }
    this._req.fetchApiData(this._url.iboSellorderListUrl, data).subscribe(
      (data) => {

        let resSucc = data['data'];
        if (resSucc !== '') {
          this.iboSellOrder = data['data'];
        } else {
          this.noRecord = data['error']['errorDescription'];
        }
      }, (error) => {
      });
  }

  // private getTradingHestory(): void {
  // this._req.fetchApiData(this._url.tradingHistory, data).subscribe(
  //   (data) => {
  //     if (data) {
  //       let success = data['data'];
  //       let error = data['error'];
  //       if (success !== "") {
  //        this.demoSellOrder=success;
  //       } else {
  //         this.errorMessage = error['Error Description']
  //       }
  //     }
  //   }, (error) => {
  //   });
  // }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/investor/edituser/investor-edit-user.component.ts